<template>
  <Plug
    v-if="!isGroupLoading && groups.length === 0"
    title="Команды не найдены"
    subtitle="Попробуй изменить фильтр или создай новую команду"
  />
  <Table v-else :nav-titles="navTitles">
    <template #nav>
      <NavCell
        v-for="title in navTitles"
        :key="title.id"
        :class="{ '-pointer-': title.sortType !== undefined }"
        @click.native="setSort(title)"
      >
        <span>{{ title.title }}</span>
        <Icon
          v-if="title.sortType !== undefined"
          class="ui-space-table__icon -arrow-"
          icon="ui-down"
          :class="{
            '-active-': title.channelId === sortChanel,
            '-rotate-': title.sortType
          }"
        />
      </NavCell>
    </template>
    <TeamList :nav-titles="navTitles" />
  </Table>
</template>

<script>
import { mapState } from 'vuex';
import Table from '../../../components/Table';
import NavCell from '../../../components/Table/NavCell';
import Plug from '@/components/UiKit/Plug';
import TeamList from './components/TeamList';

export default {
  name: 'TeamTable',
  components: {
    Table,
    NavCell,
    TeamList,
    Plug
  },
  props: {
    sortChanel: {},
    navTitles: {}
  },
  data: () => ({
    loadMore: false
  }),
  computed: {
    ...mapState('ratingTeams', {
      groups: s => s.data.groups,
      isGroupLoading: s => s.meta.isGroupLoading
    }),
    isAdmin() {
      return this.$store.state['auth'].data.user.permissions.isAdmin;
    },
    loading() {
      return this.isLoading || this.isLoadingPage;
    }
  },
  methods: {
    goTo(user) {
      if (!this.isAdmin) {
        return;
      }
      this.$router.push(`/rating/unified/user/${user.id}`);
    },
    setSort(title) {
      if (title.channel === undefined && title.sortType === undefined) {
        return;
      }
      this.$emit('setSort', title);
    }
  }
};
</script>
